exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-banner[data-v-6e6a89d4] {\n  width: 375px;\n  min-height: 150px;\n}\n[data-v-6e6a89d4] .image-slot {\n  width: 375px;\n  text-align: center;\n  line-height: 140px;\n  background-color: #eef0f5;\n}\n[data-v-6e6a89d4] .el-carousel__button {\n  width: 15px;\n}\n", ""]);

// exports
